import { Injectable } from '@angular/core';
import { ApplicationHttpClient } from '../../components/shared/http/application-http-client';
import { Routes } from '../../config/routes';
import { map } from 'rxjs/operators';
import { Organization, OrganizationResponse } from '../../models/entities/organization';
import { Observable } from 'rxjs';
import { SimpleOrganization } from '../organization/organization.service';
import { OrganizationDataService } from '../organization/organization-data.service';
import { Organizations } from '../../components/shared/http/request-interfaces';

@Injectable({
    providedIn: 'root',
})
export class PmcOrganizationsService
{
    constructor(
            private _http: ApplicationHttpClient,
            private _organizationDataService: OrganizationDataService,
    ) {
    }

    /**
     * @param pmcId
     * @param request
     * @returns {Object}
     */
    public updateBulkPropertyManagementOrganizations(
            pmcId: number,
            request: Organizations.UpdateOrganizationsForPmcRequest,
    ): Observable<Object> {

        const url: string = Routes.MakeLegFiCoreUrl(
                Routes.PMCV2Module.PmcOrganizations(pmcId),
        );

        return this._http.patch(url, JSON.stringify(request));
    }


    /**
     * @param pmcId
     * @param orgId
     * @returns {Observable<Organization>}
     */
    public getPropertyManagementOrganization(pmcId: number, orgId: number): Observable<Organization> {
        const url: string = Routes.MakeLegFiCoreUrl(
                Routes.PMCV2Module.PmcOrganization(pmcId, orgId),
        );

        return this._http.get(url).pipe(map((res: any) => new Organization(res)));
    }

    public getPropertyManagementOrganizations(
            pmcId: number,
            search: string = '',
            sortColumn: string = 'name',
            sortDirection: string = 'asc',
            pageIndex: number = 1,
            perPage: number = 100,
            filters: { [key: string]: any } = {},
    ) {
        const query = this._http.queryStringFromObject({
            page: pageIndex,
            search: search,
            column: sortColumn,
            direction: sortDirection,
            per_page: perPage,
            ...filters,
        });

        const url: string = Routes.MakeLegFiCoreUrl(
                Routes.PMCV2Module.PmcOrganizations(pmcId) + query,
        );
        return this._http.get(url).pipe(map((res) => {
            return new OrganizationResponse(res);
        }));
    }

    public getPropertyManagementOrganizationList(pmcId: number) {
        const url: string = Routes.MakeLegFiCoreUrl(
                Routes.PMCV2Module.PmcOrganizationList(pmcId),
        );
        return this._http.get(url).pipe(
                map((res: Object[]) => {
                    return res.map((r) => new SimpleOrganization(r));
                }),
                map((data: SimpleOrganization[]) => {
                    this._organizationDataService.refreshOrgList(data);
                    return data;
                }),
        );
    }

    public getAvailableOrganizationsToAssignToPmc(searchString: string) {
        const url: string = Routes.MakeLegFiCoreUrl(
                Routes.PMCV2Module.PropertyManagementCompaniesAvailableOrganizations(),
        ) + this._http.queryStringFromObject({
            term: searchString,
        });
        return this._http.get(url).pipe(
                map((res: Object[]) => {
                    return res.map((r) => new SimpleOrganization(r));
                }),
        );
    }

    /**
     * @param pmcId
     * @param orgId
     * @param request
     * @returns {Object}
     */
    public copyPropertyManagementCompanyOrganizationContent(
            pmcId: number,
            orgId: number,
            request: any,
    ): Observable<Object> {
        const url: string = Routes.MakeLegFiCoreUrl(
                Routes.PMCV2Module.PmcOrganizationCopyContent(pmcId, orgId),
        );

        return this._http.post(url, JSON.stringify(request));
    }

}
